import { RetiringData, CachedRetiringData } from '../types/Notifications.types.js';

import TopNotificationAlertEvent from '../events/TopNotificationAlertEvent.js';

import { getData } from './script_data.js';

let cachedRetiringData: CachedRetiringData | null = null;

export const getRetiringData = (): CachedRetiringData | null => {
  const retiringData = getData('/retiring_data') as RetiringData;
  if (!retiringData) {
    return null;
  }

  if (!cachedRetiringData) {
    cachedRetiringData = {
      retiringFamiliesSlugs: new Set(retiringData.retiringFamilies.map(family => family.slug)),
      retiringFoundriesSlugs: new Set(retiringData.retiringFoundries.map(foundry => foundry.slug)),
      ...retiringData
    };
  }

  return cachedRetiringData;
};

export const dispatchRetirementNotificationAlert = (type: 'family' | 'foundry', slug: string, name: string, synced: boolean) => {
  const retiringData = getRetiringData();
  if (!retiringData) {
    return;
  }

  const isRetiring = type === 'family' ?
    retiringData.retiringFamiliesSlugs.has(slug)
    : retiringData.retiringFoundriesSlugs.has(slug);

  if (isRetiring) {
    const event = new TopNotificationAlertEvent(name, slug, synced, type, isRetiring);
    document.dispatchEvent(event);
  }
};
